module.exports = __webpack_public_path__ + "static/media/dots-testimonials.7e60f659.svg";